
$('.header-search > a').on('click',function(e){
    e.preventDefault();
    
    var $search = $(this).parents('.header-search');

    $search.toggleClass('closed').toggleClass('open');

    if( $search.hasClass('open') ){
        $search.find('input').focus();
    }

});



